export default (state, action) => {
    let key = action.identifier;
    return Object.assign({}, state, {
        modal: {[key]: false}
    });
};